<ion-app>
    <ion-router-outlet *ngIf="!showSplash" [animated]="false" id="main-content"></ion-router-outlet>
    <app-toast-msg [ngClass]="toastService.modalPopupAlert ? 'modal-popup-alert' : null"></app-toast-msg>
    <app-landing-screen *ngIf="showSplash"></app-landing-screen>
</ion-app>